export const SortDetailsLink = () => (
    <a href="/reise/info/#pakkereiser" target="_blank" className="u-pl16--gt768">
        <i className="icon icon--info u-valign-bottom u-mr4" />
        Slik sorteres søkeresultatene
    </a>
);
